import React from 'react';
import { motion } from 'framer-motion';
import heroImage from '../assets/hero.png';
import bbglamImage from '../assets/bb glam salon (3).png';
import './Home-dark.css';

const Home = () => {
  return (
    <div className="home-container">
      {/* Wave Background */}
      <div className="wave-bg">
        <div className="wave wave-1"></div>
        <div className="wave wave-2"></div>
        <div className="wave wave-3"></div>
      </div>

      {/* Floating background shapes */}
      <div className="floating-shape" style={{ top: '10%', right: '5%', width: '300px', height: '300px' }} />
      <div className="floating-shape" style={{ bottom: '15%', left: '8%', width: '200px', height: '200px' }} />

      {/* Hero Section */}
      <div className="hero">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>Experience Beauty Redefined</h1>
          <p>Discover your perfect look with our expert stylists and premium beauty treatments designed to enhance your natural beauty and boost your confidence.</p>
          <div className="cta-buttons">
            <button className="primary-btn">Book Now</button>
            <button className="secondary-btn">Our Services</button>
          </div>
        </motion.div>

        <motion.div
          className="hero-image"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <img
            src={heroImage}
            alt="Salon Services"
            className="hero-img"
          />
        </motion.div>
      </div>

      {/* New Featured Section with Connecting Lines */}
      <section className="featured-section">
        <div className="container">
          <div className="featured-content">
            <div className="featured-text">
              <div className="section-header">
                <span className="section-number">01</span>
                <h2 className="section-title">Welcome to Our Beauty Haven</h2>
              </div>
              <p className="section-description">
                Experience the perfect blend of luxury and relaxation at our premier beauty destination.
                Our expert stylists are dedicated to bringing out your natural beauty with personalized
                treatments and the latest beauty techniques.
              </p>
              <div className="diagonal-rectangle"></div>
              <div className="featured-points">
                <div className="featured-point">
                  <span className="point-number">01</span>
                  <div className="point-content">
                    <h3>Expert Stylists</h3>
                    <p>Professional team with years of experience</p>
                  </div>
                </div>
                <div className="featured-point">
                  <span className="point-number">02</span>
                  <div className="point-content">
                    <h3>Premium Products</h3>
                    <p>Only the finest quality products used</p>
                  </div>
                </div>
                <div className="featured-point">
                  <span className="point-number">03</span>
                  <div className="point-content">
                    <h3>Personalized Care</h3>
                    <p>Treatments tailored to your needs</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="featured-image">
              <div className="image-container">
                <img src={bbglamImage} alt="Beauty Services" />
                <div className="experience-badge">
                  <span className="years">10+</span>
                  <span className="text">Years of Excellence</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="connecting-line"></div>
      </section>
      {/* Amazing Wigs Collection Section */}
      <section className="creative-cuts-section">
        <div className="creative-cuts-container">
          <div className="creative-cuts-text">
            <span className="section-tag">Premium Collection</span>
            <h2>Our Exquisite Wig Collection</h2>
            <p>Each piece is crafted with precision using 100% human hair, designed to enhance your natural beauty with unmatched quality and style.</p>
          </div>

          <div className="creative-cuts-images">
            {/* Wig 1 */}
            <div className="wig-card">
              <div className="wig-image-container">
                <img
                  src={require('../assets/hair-straigth.webp')}
                  alt="Silky Straight Wig"
                  className="wig-image"
                  loading="lazy"
                />
                <div className="wig-overlay">
                  <h3 className="wig-title">Silky Straight</h3>
                  <span className="wig-price"></span>
                  <div className="wig-features">
                    <span className="wig-feature"><i className="fas fa-check"></i> 100% Human Hair</span>
                    <span className="wig-feature"><i className="fas fa-ruler"></i></span>
                    <span className="wig-feature"><i className="fas fa-palette"></i> 8 Colors</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Wig 2 */}
            <div className="wig-card">
              <div className="wig-image-container">
                <img
                  src={require('../assets/Untitled design.png')}
                  alt="Luscious Body Wave"
                  className="wig-image"
                />
                <div className="wig-overlay">
                  <h3 className="wig-title">Luscious Body Wave</h3>
                  <span className="wig-price"></span>
                  <div className="wig-features">
                    <span className="wig-feature"><i className="fas fa-check"></i> 100% Human Hair</span>
                    <span className="wig-feature"><i className="fas fa-ruler"></i></span>
                    <span className="wig-feature"><i className="fas fa-palette"></i> 6 Colors</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Wig 3 */}
            <div className="wig-card">
              <div className="wig-image-container">
                <img
                  src={require('../assets/bouncy.jpeg')}
                  alt="Bouncy Curly"
                  className="wig-image"
                />
                <div className="wig-overlay">
                  <h3 className="wig-title">Bouncy Curly</h3>
                  <span className="wig-price"></span>
                  <div className="wig-features">
                    <span className="wig-feature"><i className="fas fa-check"></i> 100% Human Hair</span>
                    <span className="wig-feature"><i className="fas fa-ruler"></i> </span>
                    <span className="wig-feature"><i className="fas fa-palette"></i> 8 Colors</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Wig 4 */}
            <div className="wig-card">
              <div className="wig-image-container">
                <img
                  src={require('../assets/coloring.webp')}
                  alt="Hair Colouring"
                  className="wig-image"
                />
                <div className="wig-overlay">
                  <h3 className="wig-title">Hair Colouring </h3>
                  <span className="wig-price"></span>
                  <div className="wig-features">
                    <span className="wig-feature"><i className="fas fa-check"></i> 100% Natural  Hair Colors </span>
                    <span className="wig-feature"><i className="fas fa-ruler"></i></span>
                    <span className="wig-feature"><i className="fas fa-palette"></i> 10 Colors</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="decorative-shape-1"></div>
        <div className="decorative-shape-2"></div>
      </section>

      {/* Enhanced About BB Glam Styling Section */}
      <section className="about-bbglam-section">
        {/* Decorative Background Elements */}
        <div className="decorative-elements">
          <div className="gold-ornament gold-1"></div>
          <div className="gold-ornament gold-2"></div>
          <div className="gold-ornament gold-3"></div>
          <div className="floral-pattern"></div>
          <div className="geometric-shape shape-1"></div>
          <div className="geometric-shape shape-2"></div>
        </div>

        <div className="container about-bbglam-container">
          {/* Section Header with Premium Styling */}
          <motion.div
            className="section-header-bbglam"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <span className="section-label">Our Story</span>
            <h2 className="about-bbglam-title">
              <span className="title-line">About</span>
              <span className="title-accent">BB Glam</span>
              <span className="title-line">Styling</span>
            </h2>
            <div className="title-divider">
              <div className="divider-line"></div>
              <div className="divider-dot"></div>
              <div className="divider-line"></div>
            </div>
          </motion.div>

          {/* Main Content with Glassmorphism */}
          <motion.div
            className="about-bbglam-content"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="glass-card">
              <div className="card-content">
                <motion.p
                  className="about-bbglam-text"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  viewport={{ once: true }}
                >
                  <span className="text-highlight">BB Glam Styling</span> is dedicated to enhancing your natural beauty with expert styling and premium beauty treatments. Our experienced team combines creativity and professionalism to deliver personalized services that make you look and feel your best.
                </motion.p>
              </div>
            </div>
          </motion.div>

          {/* Decorative Bottom Elements */}
          <motion.div
            className="decorative-bottom"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="signature-line">
              <span>Excellence in Beauty Since 2014</span>
            </div>
          </motion.div>

          {/* Stylist Introduction Section */}
          <motion.div
            className="stylist-introduction"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.0 }}
            viewport={{ once: true }}
          >
            <div className="stylist-container">
              <div className="stylist-image">
                <img
                  src="https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=400&q=80"
                  alt="Our Expert Stylist"
                  className="stylist-img"
                />
                <div className="stylist-overlay">
                  <span className="experience-badge">10+ Years Experience</span>
                </div>
              </div>
              <div className="stylist-content">
                <h3 className="stylist-name">Meet Our Lead Stylist</h3>
                <h2 className="stylist-name-main">John</h2>
                <h2 className="stylist-title">Professional Beauty Expert</h2>
                <p className="stylist-description">
                  With over a decade of experience in the beauty industry, John brings unparalleled
                  expertise and creativity to every appointment. Specializing in precision cuts, color transformations,
                  and personalized styling, she is dedicated to helping you discover your unique beauty and confidence.
                </p>
                <div className="stylist-quote">
                  <blockquote>
                    "Beauty is not just about looking good, it's about feeling confident and empowered in your own skin."
                  </blockquote>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Floating Particles */}
        <div className="floating-particles">
          {[...Array(15)].map((_, i) => (
            <div
              key={i}
              className="particle"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${3 + Math.random() * 2}s`
              }}
            ></div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home;
